import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './app/globals.css';
import { ThemeProvider } from '@/components/ThemeProvider';
import { Toaster } from 'react-hot-toast';

// --- Fix for Safari 100vh bug on iPhone ---
const updateVH = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
window.addEventListener('resize', updateVH);
window.addEventListener('orientationchange', updateVH);
updateVH();
// ------------------------------------------

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: { background: "#1a1a2e", color: "#fff", borderRadius: "16px", padding: "12px 20px" },
        }}
      />
    </ThemeProvider>
  </React.StrictMode>
);
